import { MutationTree } from 'vuex';
import { ClipboardState } from './state';

export const mutations: MutationTree<ClipboardState> = {
  SET_CLIPBOARD(state, values: string[]) {
    state.clipboardValues = values;
  },
  CLEAR_CLIPBOARD(state) {
    state.clipboardValues = [];
  },
};
